import {getAffiliatePoint} from '@web/actions/affiliatePoint'
import {AffiliatePointStatus, APIStatus} from '@web/core/constants'
import makeSlice from '@web/slices/affiliatePoint/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state) => {
                // 결제하는것+관련설명 외 메인이 아닌것들?은 다 제외
                state.status = AffiliatePointStatus.NEVER
            })
            .addCase(getAffiliatePoint.pending, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addCase(getAffiliatePoint.fulfilled, (state, {payload}) => {
                // https://wiki.navercorp.com/pages/viewpage.action?pageId=383758002
                // 299,999 를 대응합니다.
                const {body, resultCode, message} = payload
                state.amount = body ?? 0
                state.resultCode = resultCode
                state.message = message
                state.scene = APIStatus.RESOLVED
            })
            .addCase(getAffiliatePoint.rejected, (state) => {
                state.amount = 0
                state.scene = APIStatus.REJECTED
            })
    },
})

export default slice.reducer
